import * as ss from 'superstruct';
import { AuPolicy } from '../oauth';
import { OrgDto } from '../user';
import { fromEnum } from '../utils/from-enum';

/** The only database the e2e seed server may drop and recreate. */
export const E2eDatabase = 'auv2-e2e';

/**
 * Contract of the test-only seed server (platform/apps/e2e-support) used by
 * the Playwright suite (packages/e2e). The deployed platform never serves it.
 */
export const E2eSeedTenantRequest = ss.object({
  policies: ss.array(fromEnum(AuPolicy)),
});

export type E2eSeedTenantRequest = ss.Infer<typeof E2eSeedTenantRequest>;

/** A fresh org with a single member, so tests never share rows. */
export const E2eSeededTenant = ss.object({
  email: ss.string(),
  org: OrgDto,
});

export type E2eSeededTenant = ss.Infer<typeof E2eSeededTenant>;
